import React, { FC } from "react";
import EditIcon from "../../../../../../images/products/edit-blue.svg";
import TrashIcon from "../../../../../../images/products/trash-blue.svg";
import SortableIcon from "../../../../../../images/products/sortable-blue.svg";
import { Col, Row } from "react-bootstrap";
// import { ReactSortable } from "react-sortablejs";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import { ProductAttributesModel } from "../../../shared/models";
import { PropertyButtons } from "../../../shared/styles";
import SortablePlugin from "../../../shared/components/SortablePlugin";
import { observer } from "mobx-react";

type IProps = {
  attributes: ProductAttributesModel[];
  onDelete: (idx: number) => void;
  onEdit: (idx: number) => void;
  onSortChange: (attributes: ProductAttributesModel[]) => void;
};
const ProductAttributeSection: FC<IProps> = ({
  attributes,
  onDelete,
  onEdit,
  onSortChange,
}: IProps) => {
  const handleSortEnd = (sortedKeys: string[]) => {
    const sortedAttributes = sortedKeys
      .map((key) => attributes.find((attr) => attr.id === key))
      .filter(Boolean);
    onSortChange(sortedAttributes as ProductAttributesModel[]);
  };

  return (
    <>
      <SortablePlugin onSortEnd={handleSortEnd} animation={150}>
        {attributes &&
          attributes.map((d, idx) => {
            return (
              <div key={d.id} data-key={d.id}>
                <Row className="variant-header">
                  <Col md={2}>
                    <img src={SortableIcon} className="variant-sort-icon" />
                    <CustomLabel margin="0px 0px 0px 15px" lineHeight="32px">
                      {d.name}
                    </CustomLabel>
                  </Col>
                  <Col md={8}>
                    <FlexContainer spacing={15} alignItems="center">
                      {d.options &&
                        d.options.map((op, index) => {
                          return (
                            <PropertyButtons
                              key={index}
                              className="text-ellipsis"
                            >
                              {op.name}
                            </PropertyButtons>
                          );
                        })}
                      <img
                        src={EditIcon}
                        onClick={() => onEdit(idx)}
                        className="variant-edit-icon"
                      />
                      <img
                        src={TrashIcon}
                        onClick={() => onDelete(idx)}
                        className="variant-trash-icon"
                      />
                    </FlexContainer>
                  </Col>
                </Row>
              </div>
            );
          })}
      </SortablePlugin>
    </>
  );
};

export default observer(ProductAttributeSection);
